import { ApiResponse, buildQueryString, get, request } from "core-web/libs/GrebbCommerceAPI/util";

import { API_URL } from "core-web/constants";
import { getModel } from "core-web/state";

type JWTProviders = "google" | "api";

export default async (token: string, provider: JWTProviders, baseUrl?: string, applicationId = 1) => {
    let response: ApiResponse | null = null;

    if (!API_URL && baseUrl) {
        const builtParameters = buildQueryString({ token, provider });
        const requestUrl = `/frontend/product/jwt/verify?application_id=${applicationId}${
            builtParameters && `&${builtParameters}`
        }`;

        response = await request({ method: "GET", path: requestUrl, baseUrl } as any);
    } else {
        response = await get(`/frontend/product/jwt/verify`, {
            application_id: getModel("application").applicationId || applicationId,
            token,
            provider,
        });
    }

    const body = await response.body();

    if (!response.ok()) {
        throw new Error("Unable to verify token.");
    }

    return body;
};
